/**
 * @param {string} lineColor
 * @param {number} highDetailMinZoom
 * @param {number} zoom
 * @return {google.maps.IconSequence[]}
 */
export function createArrowIconSequence(lineColor, highDetailMinZoom, zoom) {
  return [
    {
      icon: /** @type {google.maps.Symbol} */ ({
        path: 'm8.5777 0-8.5777 15.047 17.32-0.0952z',
        scale: 1,
        anchor: new google.maps.Point(8.66, 7.5235),
        fillOpacity: 1,
        fillColor: lineColor,
        strokeOpacity: 0,
      }),
      offset: zoom >= highDetailMinZoom ? '200px' : '50%',
      repeat: zoom >= highDetailMinZoom ? '200px' : '0',
    },
  ];
}
